// Painting category data definitions
import { TIMELINE_OPTIONS } from '../../data/constants';

// ==================== INTERIOR PAINTING: Room Configuration ====================
export const INTERIOR_PAINTING_ROOMS = [
  { value: "entire_interior", label: "Entire Interior", isWholeHouse: true },
  { value: "master_bedroom", label: "Master Bedroom", price: { low: 525, high: 800 } },
  { value: "bedroom_2", label: "Bedroom 2", price: { low: 375, high: 575 } },
  { value: "bedroom_3", label: "Bedroom 3", price: { low: 325, high: 500 } },
  { value: "bedroom_4_plus", label: "Bedroom 4+", price: { low: 325, high: 500 } },
  { value: "living_room", label: "Living Room", price: { low: 400, high: 700 } },
  { value: "dining_room", label: "Dining Room", price: { low: 350, high: 550 } },
  { value: "kitchen", label: "Kitchen", price: { low: 400, high: 650 } },
  { value: "bathroom", label: "Bathroom(s)", price: { low: 325, high: 650 } },
  { value: "hallway", label: "Hallway", price: { low: 200, high: 400 } },
  { value: "office", label: "Office", price: { low: 350, high: 550 } },
  { value: "laundry_room", label: "Laundry Room", price: { low: 250, high: 400 } },
  { value: "garage", label: "Garage", price: { low: 400, high: 800 } },
  { value: "other_room", label: "Other", price: { low: 300, high: 500 } }
];

// Room size modifiers
export const ROOM_SIZE_MODIFIERS = {
  small: { multiplier: 0.8, label: "Small (under 120 sq ft)" },
  medium: { multiplier: 1.0, label: "Medium (120-200 sq ft)" },
  large: { multiplier: 1.3, label: "Large (over 200 sq ft)" }
};

// Paintable surfaces with pricing
export const PAINTING_SURFACES = [
  { value: "walls", label: "Walls", default: true, price: { low: 0, high: 0 } },
  { value: "ceiling", label: "Ceiling", price: { low: 75, high: 150 } },
  { value: "baseboards", label: "Baseboards", price: { low: 50, high: 100 } },
  { value: "door_trim", label: "Door Trim", price: { low: 35, high: 60 } },
  { value: "window_trim", label: "Window Trim", price: { low: 35, high: 60 } },
  { value: "crown_molding", label: "Crown Molding", price: { low: 75, high: 150 } },
  { value: "closets", label: "Closets", price: { low: 100, high: 200 } },
  { value: "shelving", label: "Shelving", price: { low: 50, high: 100 } },
  { value: "pantry", label: "Pantry", price: { low: 125, high: 250 } },
  { value: "mantel", label: "Mantel", price: { low: 75, high: 150 } },
  { value: "interior_doors", label: "Interior Doors", price: { low: 175, high: 250 } },
  { value: "kitchen_cabinets", label: "Kitchen Cabinets", price: { low: 2200, high: 5500 } },
  { value: "bathroom_vanities", label: "Bathroom Vanities", price: { low: 400, high: 800 } }
];

// Drywall options
export const DRYWALL_OPTIONS = [
  { value: "none", label: "None needed", price: { low: 0, high: 0 } },
  { value: "minor", label: "Minor Repairs (nail holes, small patches)", price: { low: 100, high: 250 } },
  { value: "major", label: "Major Repairs (large holes, multiple areas)", price: { low: 300, high: 600 } },
  { value: "replacement", label: "Drywall Replacement", price: { low: 500, high: 1200 } }
];

// ==================== EXTERIOR PAINTING: Items Configuration ====================
export const EXTERIOR_PAINTING_ITEMS = [
  { value: "entire_exterior", label: "Entire Exterior", isWholeHouse: true, price: { low: 2500, high: 8000 } },
  { value: "siding", label: "Siding", hasFollowUp: true, price: { low: 800, high: 2500 } },
  { value: "fascia", label: "Fascia", price: { low: 200, high: 500 } },
  { value: "soffit", label: "Soffit", price: { low: 250, high: 600 } },
  { value: "window_trim_ext", label: "Window Trim", price: { low: 150, high: 400 } },
  { value: "gutters", label: "Gutters", price: { low: 200, high: 500 } },
  { value: "front_door", label: "Front Door", price: { low: 150, high: 300 } },
  { value: "back_door", label: "Back Door", price: { low: 150, high: 300 } },
  { value: "garage_door", label: "Garage Door", price: { low: 250, high: 500 } },
  { value: "porch", label: "Porch", price: { low: 300, high: 700 } },
  { value: "deck", label: "Deck", hasFollowUp: true, price: { low: 400, high: 1000 } },
  { value: "stairs_ext", label: "Stairs", price: { low: 150, high: 350 } },
  { value: "posts", label: "Posts", price: { low: 100, high: 250 } },
  { value: "railings", label: "Railings", price: { low: 150, high: 400 } },
  { value: "shutters", label: "Shutters", price: { low: 200, high: 500 } },
  { value: "awning", label: "Awning", price: { low: 150, high: 350 } }
];

// Siding coverage options
export const SIDING_COVERAGE_OPTIONS = [
  { value: "one_side", label: "One Side", multiplier: 0.25 },
  { value: "two_sides", label: "Two Sides", multiplier: 0.5 },
  { value: "three_sides", label: "Three Sides", multiplier: 0.75 },
  { value: "entire_house", label: "Entire House", multiplier: 1.0 }
];

// ==================== PAINTING QUESTIONS ====================
export const PAINTING_QUESTIONS = [
  // Step 1: Interior vs Exterior
  {
    id: "painting_type",
    question: "What type of painting project do you have?",
    type: "radio",
    options: [
      { value: "interior", label: "Interior Painting" },
      { value: "exterior", label: "Exterior Painting" }
    ]
  },
  
  // ==================== INTERIOR PAINTING FLOW ====================
  {
    id: "interior_scope",
    question: "What would you like painted?",
    type: "radio",
    showIf: { painting_type: "interior" },
    options: [
      { value: "entire_interior", label: "Entire Interior" },
      { value: "individual_rooms", label: "Individual Rooms" }
    ]
  },
  
  // ==================== ENTIRE INTERIOR FLOW ====================
  {
    id: "entire_interior_bedrooms",
    question: "How many bedrooms?",
    type: "radio",
    showIf: { painting_type: "interior", interior_scope: "entire_interior" },
    options: [
      { value: "1", label: "1 bedroom" },
      { value: "2", label: "2 bedrooms" },
      { value: "3", label: "3 bedrooms" },
      { value: "4", label: "4 bedrooms" },
      { value: "5+", label: "5+ bedrooms" }
    ]
  },
  {
    id: "entire_interior_bathrooms",
    question: "How many bathrooms?",
    type: "radio",
    showIf: { painting_type: "interior", interior_scope: "entire_interior" },
    options: [
      { value: "1", label: "1 bathroom" },
      { value: "2", label: "2 bathrooms" },
      { value: "3", label: "3 bathrooms" },
      { value: "4+", label: "4+ bathrooms" }
    ]
  },
  {
    id: "entire_interior_includes",
    question: "What should be included? (Select all that apply)",
    type: "checkbox",
    showIf: { painting_type: "interior", interior_scope: "entire_interior" },
    options: [
      { value: "walls", label: "Walls (included)" },
      { value: "ceilings", label: "Ceilings" },
      { value: "baseboards_trim", label: "Baseboards & Trim" },
      { value: "doors", label: "Interior Doors" },
      { value: "cabinets", label: "Kitchen Cabinets" },
      { value: "closets", label: "Closets" }
    ]
  },
  {
    id: "entire_interior_drywall",
    question: "Any drywall repairs needed?",
    type: "radio",
    showIf: { painting_type: "interior", interior_scope: "entire_interior" },
    options: [
      { value: "none", label: "None" },
      { value: "minor", label: "Minor Repairs (nail holes, small patches)" },
      { value: "major", label: "Major Repairs (large holes, multiple areas)" },
      { value: "replacement", label: "Drywall Replacement" }
    ]
  },
  
  // ==================== INDIVIDUAL ROOMS FLOW ====================
  {
    id: "selected_rooms",
    question: "Which rooms do you need painted?",
    subtitle: "Select all rooms that apply",
    type: "checkbox",
    showIf: { painting_type: "interior", interior_scope: "individual_rooms" },
    options: [
      { value: "master_bedroom", label: "Master Bedroom" },
      { value: "bedroom_2", label: "Bedroom 2" },
      { value: "bedroom_3", label: "Bedroom 3" },
      { value: "bedroom_4_plus", label: "Bedroom 4+" },
      { value: "living_room", label: "Living Room" },
      { value: "dining_room", label: "Dining Room" },
      { value: "kitchen", label: "Kitchen" },
      { value: "bathroom", label: "Bathroom(s)" },
      { value: "hallway", label: "Hallway" },
      { value: "office", label: "Office" },
      { value: "laundry_room", label: "Laundry Room" },
      { value: "garage", label: "Garage" },
      { value: "other_room", label: "Other" }
    ]
  },
  
  // Room-by-room details
  {
    id: "room_details",
    question: "Tell us about each room",
    subtitle: "Expand each room to specify size and surfaces to paint",
    type: "collapsible_room_details",
    showIf: { painting_type: "interior", interior_scope: "individual_rooms" },
    roomsSourceId: "selected_rooms",
    roomConfig: INTERIOR_PAINTING_ROOMS,
    surfaces: PAINTING_SURFACES,
    sizeOptions: ROOM_SIZE_MODIFIERS,
    drywallOptions: DRYWALL_OPTIONS
  },
  
  // Wall color change question
  {
    id: "wall_color_change",
    question: "Are you changing wall colors or keeping the same?",
    type: "radio",
    showIf: { painting_type: "interior", interior_scope: "individual_rooms" },
    options: [
      { value: "same_color", label: "Same Color (touch-up/refresh)" },
      { value: "color_change", label: "Color Change" }
    ]
  },
  
  // Common interior questions
  {
    id: "home_occupied",
    question: "Is the home furnished and occupied?",
    type: "radio",
    showIf: { painting_type: "interior" },
    options: [
      { value: "furnished_occupied", label: "Furnished and occupied" },
      { value: "furnished_unoccupied", label: "Furnished but unoccupied" },
      { value: "unfurnished_unoccupied", label: "Unfurnished and unoccupied" }
    ]
  },
  {
    id: "interior_ceiling_height",
    question: "What is your ceiling height?",
    type: "radio",
    showIf: { painting_type: "interior" },
    options: [
      { value: "standard", label: "Standard (8-9 ft)" },
      { value: "high", label: "High (10-12 ft)" },
      { value: "very_high", label: "Very high (12+ ft)" }
    ]
  },
  
  // ==================== EXTERIOR PAINTING FLOW ====================
  {
    id: "exterior_items",
    question: "What do you need painted? (Select all that apply)",
    type: "checkbox",
    showIf: { painting_type: "exterior" },
    options: EXTERIOR_PAINTING_ITEMS.map(item => ({
      value: item.value,
      label: item.label
    }))
  },
  
  // Siding coverage follow-up
  {
    id: "siding_coverage",
    question: "How much of the house siding needs painting?",
    type: "radio",
    showIf: { painting_type: "exterior" },
    showIfIncludes: { exterior_items: "siding" },
    options: SIDING_COVERAGE_OPTIONS.map(opt => ({
      value: opt.value,
      label: opt.label
    }))
  },
  
  // Deck follow-up
  {
    id: "deck_finish",
    question: "What finish for the deck?",
    type: "radio",
    showIf: { painting_type: "exterior" },
    showIfIncludes: { exterior_items: "deck" },
    options: [
      { value: "paint", label: "Paint" },
      { value: "stain", label: "Stain" }
    ]
  },
  
  // Exterior surface material
  {
    id: "surface_material",
    question: "What is the main surface material?",
    type: "radio",
    showIf: { painting_type: "exterior" },
    options: [
      { value: "wood", label: "Wood" },
      { value: "vinyl", label: "Vinyl" },
      { value: "stucco", label: "Stucco" },
      { value: "brick", label: "Brick" },
      { value: "metal", label: "Metal" },
      { value: "other", label: "Other" },
      { value: "not_sure", label: "Not sure" }
    ]
  },
  
  // Stories - exterior only
  {
    id: "stories",
    question: "How tall is your home?",
    type: "radio",
    showIf: { painting_type: "exterior" },
    options: [
      { value: "1", label: "1 story" },
      { value: "2+", label: "2+ stories" }
    ]
  },
  
  // Timeline
  {
    id: "timeline",
    question: "When do you need this done?",
    type: "radio",
    options: TIMELINE_OPTIONS
  }
];
